module.exports = __webpack_public_path__ + "static/img/gaozhongzhengzhi.4d34850c.jpg";